import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import * as classes from './classes.module.scss';
import { WorkPropTypes } from '../../config/proptypes';
import More from '../assets/more';
import { renderTitle } from '../info/work_details';
import AddToCanvasButtons from './add_to_canvas';

export default class Work extends PureComponent {
  static propTypes = {
    ...WorkPropTypes,
    index: PropTypes.number.isRequired,
    addToCanvas: PropTypes.func.isRequired,
    showMoreLikeThis: PropTypes.func,
    moreSource: PropTypes.string.isRequired
  };

  showMoreLikeThis = () => {
    const {
      showMoreLikeThis, id, index, moreSource
    } = this.props;
    showMoreLikeThis(id, index, moreSource);
  }

  addToCanvas = (workSizeId, width, height) => {
    const { id, addToCanvas } = this.props;
    addToCanvas({
      workId: id, workSizeId, width, height
    });
  };

  renderSizes() {
    const { workSizesAttributes, landscape } = this.props;
    return (
      <AddToCanvasButtons
        workSizesAttributes={ workSizesAttributes }
        landscape={ landscape }
        addToCanvas={ this.addToCanvas }
      />
    );
  }

  render() {
    const {
      title,
      imageUrl,
      user: {
        userName
      },
      showMoreLikeThis,
      isHidden
    } = this.props;

    const showMore = showMoreLikeThis ? (
      <div className={ classes.moreDivider }>
        <button type="button" className={ classes.more } onClick={ this.showMoreLikeThis }>
          <More fill="#000" />
          <span>MORE LIKE THIS</span>
          &nbsp;
          <Icon name="chevron right" size="small" />
        </button>
      </div>
    ) : null;

    return (
      <div className={ classes.work }>
        <div className={ classes.image }>
          <img src={ imageUrl } alt={ title } />
        </div>
        <div className={ classes.inner }>
          <div className={ classes.title }>
            { renderTitle(title, userName, isHidden) }
          </div>
          <div className={ classes.sizes }>
            { this.renderSizes() }
          </div>
          { showMore }
        </div>
      </div>
    );
  }
}
